export type FilterSource = 'builder';

export interface ActiveFilter {
  field: string;
  fieldLabel: string;
  operator: string;
  operatorLabel: string;
  value: string;
  source: FilterSource;
}

export const FILTER_OPERATORS = [
  { label: 'Contains',             value: 'contains',          rsql: (f: string, v: string) => `${f}==*${v}*`    },
  { label: 'Starts with',          value: 'startsWith',        rsql: (f: string, v: string) => `${f}==${v}*`     },
  { label: 'Equals',               value: 'equals',            rsql: (f: string, v: string) => `${f}==${v}`      },
  { label: 'Not equals',           value: 'notEqual',          rsql: (f: string, v: string) => `${f}!=${v}`      },
  { label: 'Less than',            value: 'lessThan',          rsql: (f: string, v: string) => `${f}=lt=${v}`    },
  { label: 'Greater than',         value: 'greaterThan',       rsql: (f: string, v: string) => `${f}=gt=${v}`    },
  { label: 'Less than or equal',   value: 'lessThanOrEqual',   rsql: (f: string, v: string) => `${f}=le=${v}`    },
  { label: 'Greater or equal',     value: 'greaterThanOrEqual',rsql: (f: string, v: string) => `${f}=ge=${v}`    },
  { label: 'In list',              value: 'in',                rsql: (f: string, v: string) => `${f}=in=(${v})`  },
  { label: 'Not in list',          value: 'notIn',             rsql: (f: string, v: string) => `${f}=out=(${v})` },
] as const;

type OperatorEntry = typeof FILTER_OPERATORS[number];

const OPERATOR_MAP = new Map<string, OperatorEntry>(
  FILTER_OPERATORS.map((op) => [op.value, op])
);

export function translateFiltersToRsql(
  filters: ActiveFilter[],
  logic: 'AND' | 'OR' = 'AND'
): string[] {
  const parts = filters
    .filter((f) => f.value !== null && f.value.trim() !== '')
    .map((f) => {
      const op = OPERATOR_MAP.get(f.operator);
      return op ? op.rsql(f.field, f.value.trim()) : `${f.field}==${f.value.trim()}`;
    });

  if (parts.length === 0) return [];
  if (logic === 'OR' && parts.length > 1) return [parts.join(',')];
  return parts;
}
